<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">Agency Profile</legend>
    </div>
    <div class="grid-col flex-auto margin-left-2">
      <ul class="usa-nav__primary usa-accordion">
        <li class="usa-nav__primary-item">
          <button class="usa-accordion__button define-eclipse" aria-expanded="false" aria-controls="more-actions"
            data-tooltip="Click for more options">
            <span>&hellip;</span>
          </button>
          <ul id="more-actions" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a (click)="gotToAgencyUser()"> User List</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a routerLink="/agencytspsearch"> Search </a>
            </li>
            <li class="usa-nav__submenu-item">
              <a (click)="gotToAgencyToken()"> Agency Token (API) </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="grid-row">
    <legend class="usa-legend usa-legend--medium" [innerHTML]="carrierAgencyDetails"></legend>
  </div>
  @if (saveSuccessful) {
    <div class="grid-row">
      <div class="usa-alert usa-alert--success usa-alert--no-icon">
        <div class="usa-alert__body">
          <p class="usa-alert__text">
            Customer profile has been updated successfully
          </p>
        </div>
      </div>
    </div>
  }
  <form [formGroup]="agencyProfileForm" #agencyProfForm="ngForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row">
        <legend class="usa-legend usa-legend--medium">Authorized Official</legend>
      </div>
      <div class="grid-row grid-gap-0">
        <div class="grid-col-4">
          <label for="firstName" class="usa-label">First Name<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="firstName" formControlName="firstName" class="usa-input" maxlength="35"
                 [ngClass]="{
                  'border-success': this.agencyProfileForm.get('firstName').valid && this.agencyProfileForm.get('firstName').touched,
                  'border-danger': this.agencyProfileForm.get('firstName').invalid && this.agencyProfileForm.get('firstName').touched
                 }"
            >
          @if (this.agencyProfileForm.get('firstName').hasError('required') && (this.agencyProfileForm.get('firstName').touched
            || this.agencyProfileForm.get('firstName').dirty)) {
            <div>
              <small class="text-danger">
                <span class="fa fa-warning"></span> First Name is required
              </small>
            </div>
          }
          @if (this.agencyProfileForm.get('firstName').hasError('pattern')) {
            <div
              >
              <small class="text-danger"> <span class="fa fa-warning"></span>
              First Name is invalid.
            </small>
          </div>
        }
      </div>
      <div class="grid-col-4">
        <label for="middle_name" class="usa-label">Middle Initial</label>
        <input type="text" id="middle_name" formControlName="middleInitial" class="usa-input" maxlength="1">
      </div>
      <div class="grid-col-4">
        <label for="last_name" class="usa-label">Last Name<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" id="last_name" formControlName="lastName" class="usa-input" maxlength="35"
                 [ngClass]="{
                  'border-success': this.agencyProfileForm.get('lastName').valid && this.agencyProfileForm.get('lastName').touched,
                  'border-danger': this.agencyProfileForm.get('lastName').invalid && this.agencyProfileForm.get('lastName').touched
                 }"
          >
        @if (this.agencyProfileForm.get('lastName').hasError('required') && (this.agencyProfileForm.get('lastName').touched
          || this.agencyProfileForm.get('lastName').dirty)) {
          <div>
            <small class="text-danger">
              <span class="fa fa-warning"></span> Last Name is required
            </small>
          </div>
        }
        @if (this.agencyProfileForm.get('lastName').hasError('pattern')) {
          <div
            >
            <small class="text-danger"> <span class="fa fa-warning"></span>
            Last Name is invalid.
          </small>
        </div>
      }
    </div>
  </div>
  <div class="grid-row grid-gap-0">
    <div class="grid-col-4">
      <label for="title" class="usa-label">Title<abbr title="required"
      class="usa-hint usa-hint--required">*</abbr></label>
      <input type="text" id="title" formControlName="title" class="usa-input" maxlength="45"
                 [ngClass]="{
                  'border-success': this.agencyProfileForm.get('title').valid && this.agencyProfileForm.get('title').touched,
                  'border-danger': this.agencyProfileForm.get('title').invalid && this.agencyProfileForm.get('title').touched
                 }"
        >
      @if (this.agencyProfileForm.get('title').invalid) {
        <div>
          <small class="text-danger">
            <span class="fa fa-warning"></span> Title is required
          </small>
        </div>
      }
    </div>
  </div>
  <hr>
    <div class="grid-row">
      <legend class="usa-legend usa-legend--medium">Contact Information</legend>
    </div>
    <div class="grid-row grid-gap-0">
      <div class="grid-col-4">
        <label for="address" class="usa-label">Address<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" id="address" formControlName="addressLine1" class="usa-input" maxlength="45"
                 [ngClass]="{
                  'border-success': this.agencyProfileForm.get('addressLine1').valid && this.agencyProfileForm.get('addressLine1').touched,
                  'border-danger': this.agencyProfileForm.get('addressLine1').invalid && this.agencyProfileForm.get('addressLine1').touched
                 }"
          >
        @if (this.agencyProfileForm.get('addressLine1').invalid) {
          <div>
            <small class="text-danger">
              <span class="fa fa-warning"></span> Address is required
            </small>
          </div>
        }
      </div>
      <div class="grid-col-4">
        <label for="address_2" class="usa-label">Address 2</label>
        <input type="text" id="address_2" formControlName="addressLine2" class="usa-input" maxlength="45">
      </div>
      <div class="grid-col-4">
        <ng-template #customItemTemplate let-model="item">{{model.cityName}},
          {{model.stateAbbrev}} {{model.zipCode}}
        </ng-template>
        <label for="OriginSearchString" class="usa-label">Search by City or Zip: </label> <input
        id="OriginSearchString" class="usa-input"
        formControlName="asyncOriginSearchString"
        [typeaheadAsync]="true" [typeahead]="dataSourceOrigin"
        (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
        (typeaheadOnSelect)="typeaheadOriginOnSelect($event)"
        typeaheadOptionField="cityName"
        [typeaheadItemTemplate]="customItemTemplate"
        [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="10"
        [typeaheadOptionsLimit]="100"
        placeholder="Type a location or zip">
      </div>
    </div>
    <div class="grid-row grid-gap-0">
      <div class="grid-col-4">
        <label for="zip" class="usa-label">Zip Code<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" id="zip" formControlName="zip"
          readonly id="zip"
          maxlength="5" class="usa-input">
      </div>
      <div class="grid-col-4">
        <label for="city" class="usa-label">City<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" id="city" formControlName="city" class="usa-input" maxlength="45"
          readonly id="city">
      </div>
      <div class="grid-col-4">
        <label for="state" class="usa-label">State<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" id="state" formControlName="state" class="usa-input" maxlength="45"
          oninput="this.value = this.value.toUpperCase()"
          readonly id="state">
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col-4">
        <label for="country" class="usa-label">Country<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="country" formControlName="country" class="usa-select" title="reporting_country"
          (change)="changeCountry($event)" name="country">
          <option [value]='null' selected disabled>Choose...</option>
          @for (c of countryList; track c) {
            <option [value]="c.stateCountryId">{{c.stateCountryName}}</option>
          }
        </select>
        @if (this.agencyProfileForm.get('country').invalid || this.agencyProfileForm.get('country').value === 'null') {
          <div
            >
            <small class="text-danger">
              <span class="fa fa-warning"></span> Country is required
            </small>
          </div>
        }
      </div>
    </div>
    <div class="grid-row grid-gap-0">
      <div class="grid-col-4">
        <label for="phone" class="usa-label">Phone<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" id="phone" formControlName="phone" maxlength="15" class="usa-input"
                 [ngClass]="{
                  'border-success': this.agencyProfileForm.get('phone').valid && this.agencyProfileForm.get('phone').touched,
                  'border-danger': this.agencyProfileForm.get('phone').invalid && this.agencyProfileForm.get('phone').touched
                 }"
          >
        @if (this.agencyProfileForm.get('phone').invalid) {
          <div>
            <small class="text-danger">
              <span class="fa fa-warning"></span> Phone is required
            </small>
          </div>
        }
        @if (this.agencyProfileForm.get('phone').hasError('minlength')) {
          <div>
            <small class="text-danger">
              <span class="fa fa-warning"></span> Phone Number should be at least 10 digits long
            </small>
          </div>
        }
        @if (this.agencyProfileForm.get('phone').hasError('numericsOnly')) {
          <div>
            <small class="text-danger">
              <span class="fa fa-warning"></span> Phone Number is invalid - should be all numeric, no dashes, no spaces
            </small>
          </div>
        }
      </div>
      <div class="grid-col-4">
        <label for="phone_ext" class="usa-label">Ext</label>
        <input type="text" id="phone_ext" formControlName="phoneExtension" class="usa-input" [maxlength]="10">
      </div>
      <div class="grid-col-4">
        <label for="email" class="usa-label">Email<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" id="email" formControlName="email" class="usa-input" maxlength="254"
                 [ngClass]="{
                  'border-success': this.agencyProfileForm.get('email').valid && this.agencyProfileForm.get('email').touched,
                  'border-danger': this.agencyProfileForm.get('email').invalid && this.agencyProfileForm.get('email').touched
                 }"
          >
        @if (this.agencyProfileForm.get('email').invalid) {
          <div>
            <small class="text-danger">
              <span class="fa fa-warning"></span> Email is required
            </small>
          </div>
        }
        @if ((this.emailPresent)) {
          <div>
            <small class="text-danger">
              <span class="fa fa-warning"></span> An account already exists with this email address.
            </small>
          </div>
        }
      </div>
    </div>
    <div class="grid-row">
      <label class="usa-label">Permissions<abbr title="required"
      class="usa-hint usa-hint--required">*</abbr></label>
    </div>
    <div class="grid-row">
      @for (item of this.permissions; track item) {
        <div class="usa-radio">
          <input class="usa-radio__input" id= '{{item.key}}' (change)="radioButtonSelection($event,item.key)" type="radio" formControlName="access"  name="access" value='{{item.key}}'/>
          <label class="usa-radio__label" for="{{item.key}}">{{item.text}}</label>
        </div>
      }
    </div>
    <div class="grid-row grid-gap-0 margin-top-2">
      @if (this.agencyProfileForm.get('access').value === 'FRT' && this.agencyProfileForm.get('auditor').value === false) {
        <div class="grid-col-2">
          <label class="switch">
            <input type="checkbox" formControlName="syncadaPayment"/>
            <span class="slider round"></span>
          </label>
          <small class="padding-left-2">Syncada Payment ?</small>
        </div>
      }
      @if (this.agencyProfileForm.get('viewAllAgySro').value === false && this.agencyProfileForm.get('auditor').value === false) {
        <div class="grid-col-2">
          <label class="switch">
            <input type="checkbox" formControlName="viewAllSro"/>
            <span class="slider round"></span>
          </label>
          <small class="padding-left-2">View All SROs</small>
        </div>
      }
      @if (this.agencyProfileForm.get('viewAllSro').value === false && this.agencyProfileForm.get('auditor').value === false) {
        <div class="grid-col-2">
          <label class="switch">
            <input type="checkbox" formControlName="viewAllAgySro"/>
            <span class="slider round"></span>
          </label>
          <small class="padding-left-2">View All Agency SROs</small>
        </div>
      }
      @if (this.agencyProfileForm.get('auditor').value === false) {
        <div class="grid-col-2">
          <label class="switch">
            <input type="checkbox" formControlName="viewAgyBurShipments"/>
            <span class="slider round"></span>
          </label>
          <small class="padding-left-2">View Agency Bureau Shipments</small>
        </div>
      }
      <div class="grid-col-2">
        <label class="switch">
          <input type="checkbox" formControlName="auditor"/>
          <span class="slider round"></span>
        </label>
        <small class="padding-left-2">Auditor</small>
      </div>
    </div>
    <div class="grid-row margin-top-4">
      @if (this.agencyProfileForm.get('syncadaPayment').value === true) {
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="email" class="usa-label">Syncada Buyer Id</label>
          <input type="text" id="syncada_buyerId" formControlName="syncadaBuyerId" class="usa-input"  maxlength="15">
        </div>
      }
    </div>
    <hr>
      <div class="grid-row">
        <legend class="usa-legend usa-legend--medium">Notification Preferences</legend>
      </div>
      <div class="grid-row">
        <div class="grid-col-4">
          <button type="button" class="usa-button" (click) = "onModifyNotificationPreference()" > View/Modify Notification Preferences</button>
        </div>
      </div>
      <hr>
        <div class="grid-col-4">
          <label for="updateMessage" class="usa-label">Update Notes (Maximum 250 chars)<abbr title="required" class="usa-hint usa-hint--required">*</abbr>
          <button type="button" class="usa-button margin-left-2" (click) = "messageHistoryModal()" > Notes History</button>
        </label>
        <div class="usa-alert usa-alert--warning usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              The notes entered below will be included on the notification being sent to the Authorized Official.
            </p>
          </div>
        </div>

        <textarea class="usa-textarea"  id="updateMessage"
          formControlName="updateMessage" maxlength="250">
        </textarea>
        @if (this.agencyProfileForm.get('updateMessage').invalid && (this.agencyProfileForm.get('updateMessage').touched
          || this.agencyProfileForm.get('updateMessage').dirty)) {
          <div
            >
            <small class="text-danger"> <span class="fa fa-warning"></span>
            Update Note is required
          </small>
        </div>
      }
    </div>
    @if (disabled) {
      <div class="grid-row margin-top-4">
        <button type="button" class="usa-button"
          [disabled]=" this.saveSuccessful || this.agencyProfileForm.invalid || this.emailPresent"
          (click)="saveOrganization(agencyProfileForm);">Save
        </button>
        <button type="button" class="usa-button usa-button--outline" (click)="deleteOrgData();">Deactivate Customer
        </button>
        @if (!this.newProfile) {
          <button type="button" class="usa-button" (click)="viewAuditTrial()">View Audit Trail</button>
        }
      </div>
    }
    @if (!disabled) {
      <div class="grid-row margin-top-4">
        <button type="button" class="usa-button"
          [disabled]=" this.saveSuccessful || this.agencyProfileForm.invalid || this.emailPresent"
          (click)="saveOrganization(agencyProfileForm);">Save
        </button>
      </div>
    }
  </fieldset>
</form>
</div>
